/**
 * Testimonials — randomly swaps one card at a time through 3 fixed slots.
 * Uses a front/back flip-card pattern (rotateY 180deg transition).
 */
export function Testimonials() {
    const grids = document.querySelectorAll('[data-testimonials]');

    if (!grids.length) return;

    grids.forEach((grid) => {
        const slots    = Array.from(grid.querySelectorAll('.testimonial-slot'));
        const pool     = grid.parentElement.querySelector('.testimonials-pool');
        const pauseBtn = grid.parentElement.querySelector('[data-testimonials-pause]');

        if (!slots.length || !pool) return;

        const cards = Array.from(pool.querySelectorAll('.card.testimonial'));

        if (!cards.length) return;

        // Track which card index is currently in each slot
        const slotCardIndex = new Array(slots.length).fill(-1);
        let lastSlotIndex   = -1;
        let cardIndex       = 0;
        let paused          = false;
        let timer;

        // Populate slots with first 3 unique cards
        slots.forEach((slot, i) => {
            slotCardIndex[i] = cardIndex;
            slot.appendChild(cards[cardIndex].cloneNode(true));
            cardIndex = (cardIndex + 1) % cards.length;
        });

        function getNextCardIndex() {
            const visible = new Set(slotCardIndex);
            if (visible.size >= cards.length) return cardIndex;

            let next = cardIndex;
            while (visible.has(next)) {
                next = (next + 1) % cards.length;
            }
            return next;
        }

        function swap() {
            let slotIndex;
            do {
                slotIndex = Math.floor(Math.random() * slots.length);
            } while (slotIndex === lastSlotIndex && slots.length > 1);
            lastSlotIndex = slotIndex;

            const next     = getNextCardIndex();
            const slot     = slots[slotIndex];
            const outgoing = slot.firstElementChild;
            const incoming = cards[next].cloneNode(true);

            cardIndex = (next + 1) % cards.length;
            slotCardIndex[slotIndex] = next;

            // Clear is-active from all visible cards
            grid.querySelectorAll('.card.is-active').forEach(c => c.classList.remove('is-active'));

            if (outgoing) {
                outgoing.classList.add('is-leaving');

                setTimeout(() => {
                    slot.innerHTML = '';
                    incoming.classList.add('is-entering', 'is-active');
                    slot.appendChild(incoming);

                    requestAnimationFrame(() => requestAnimationFrame(() => {
                        incoming.classList.remove('is-entering');
                    }));
                }, 400);
            }
        }

        function start() {
            paused = false;
            timer  = setInterval(swap, 5000);
            if (pauseBtn) {
                pauseBtn.setAttribute('data-state', 'playing');
                pauseBtn.querySelector('span').textContent = 'Pause animation';
                pauseBtn.querySelector('.icon-toggle').src = '/marketing/wp-content/themes/marketing2025/img/homepage/Pauseicon.svg';
            }
        }

        function pause() {
            paused = true;
            clearInterval(timer);
            if (pauseBtn) {
                pauseBtn.setAttribute('data-state', 'paused');
                pauseBtn.querySelector('span').textContent = 'Play animation';
                pauseBtn.querySelector('.icon-toggle').src = '/marketing/wp-content/themes/marketing2025/img/homepage/Playicon.svg';
            }
        }

        if (pauseBtn) {
            pauseBtn.addEventListener('click', () => {
                paused ? start() : pause();
            });
        }

        start();
    });
}
